<script setup>
import { computed } from "vue";
import { Download } from "lucide-vue-next";
import { BRAND_LOGO_URL, MAC_APP_DOWNLOAD_URL } from "@/shared/config/constants";
import { formatBytes } from "@/shared/utils/format";

const props = defineProps({
  release: { type: Object, default: null },
});

const releaseLine = computed(() => {
  if (!props.release) return "DMG 发布后这里会显示版本和大小";
  return `v${props.release.version} (${props.release.arches}) · ${formatBytes(props.release.artifact?.sizeBytes)} · ${
    props.release.autoUpdate ? "自动更新已启用" : "手动更新"
  }`;
});
</script>

<template>
  <section class="download-card">
    <div class="download-copy">
      <span class="logo-chip">
        <img :src="BRAND_LOGO_URL" alt="" />
      </span>
      <div>
        <h2>小能熊 agent 经济学 mac app</h2>
        <p>下载 DMG，在菜单栏完成设备配对，App 会跟随刷新频率自动上传 CodexBar 日汇总。</p>
      </div>
    </div>
    <div class="download-actions">
      <a class="btn-amber" :href="MAC_APP_DOWNLOAD_URL">
        <Download :size="16" :stroke-width="2.6" />
        下载 dmg
      </a>
      <small>{{ releaseLine }}</small>
    </div>
  </section>
</template>
